var $ = require('jquery');

"use strict";

//doplnit pluginName
var PLUGIN_NAME = "productListFilter";
var PLUGIN_VERSION = "v1.0";

var DEFAULTS = {
	primaryContainer: '.js_product-list-container',
	containers: ['.js_product-list-items-container', '.js_product-list-filter-selected', '.js_product-list-filter-container'],
	filterFormSelector: '.js_product-list-filter-form',
	selectedItemsSelector: '.js_product-list-filter-selected',
	timerMilliseconds: 800
};

/**
 * set basic variables
 * create options and settings for this instance
 * @param element - DOM Element the plugin is applied to
 * @param options - custom settings to be merged with DEFAULTS
 * @constructor
 */
var ProductListFilter = function (element, options) {
	// merge options
	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;

	this.element = element;
	this.$t = $(this.element);
	this.filterTimer = 0;
	this.urlParams = "";
	this.initialise();
};

/**
 * init function
 */
ProductListFilter.prototype.initialise = function () {
	var self = this;
	self.$filterForm = $(self.options.filterFormSelector, self.$t);
	self.urlParams = self.serializeForm();
	self.handleEvents();
	history.replaceState({updatedContainers: self.options.containers}, document.title, window.location.href);
};

ProductListFilter.prototype.handleEvents = function () {
	var self = this;
	self.$filterForm.on('change', 'input[type="checkbox"], input[type="radio"], select', function() {
		self.filterFormChanged();
	});

	self.$filterForm.on('slideStop', '.js_bootstrap-slider-input', function() {
		var valuesArr = $(this).attr('data-value').split(',');
		if(!($.inArray($(this).data('sliderMin').toString(), valuesArr) != -1) || !($.inArray($(this).data('sliderMax').toString(), valuesArr) != -1)) {
			$(this).attr('data-state', 'active');
		} else {
			$(this).attr('data-state', 'inactive');
		}
		self.filterFormChanged();
	});

	self.$filterForm.on('click', self.options.selectedItemsSelector+' a', function(e) {
		e.preventDefault();
		self.filterFormChanged($(e.srcElement).parent('a')[0]);
	});
};

ProductListFilter.prototype.filterFormChanged = function (eventObject) {
	var self = this;

	clearTimeout(self.filterTimer);
	if(typeof eventObject !== 'undefined') {
		self.doFilter(eventObject);
	} else {
		self.filterTimer = setTimeout(function(){
			self.doFilter();
		}, self.options.timerMilliseconds);
	}
};

ProductListFilter.prototype.serializeForm = function () {
	var self = this;
	return $('input:not(.js_bootstrap-slider-input), select, input.js_bootstrap-slider-input[data-state="active"]', self.$filterForm).serialize();
};

ProductListFilter.prototype.doFilter = function (eventObject) {
	var self = this;
	var urlParams, targetUrl;

	if(typeof eventObject !== 'undefined') {
		var eventObjectHref = eventObject.href;
		if(eventObjectHref.indexOf('?') == -1) {
			urlParams = '';
		} else {
			urlParams = eventObjectHref.substring(eventObjectHref.indexOf('?')+1);
		}
		targetUrl = eventObject.href;
	} else {
		urlParams = self.serializeForm();
		targetUrl = self.$filterForm.attr('action')+'?'+urlParams;
	}

	if (urlParams != self.urlParams) {
		self.urlParams = urlParams;
		$(document).trigger('FG_UNIVERSAL_PRELOADER_START', 'PRODUCTLIST_ITEMS_CHANGE');
		$.get(targetUrl, function(data) {
			var containers = self.options.containers;
			for(var i = 0; i < containers.length; i++) {
				$(containers[i], self.$t).html($(data).find(containers[i]).html());
			}
			history.pushState({updatedContainers: containers, events: ['EDEESHOP_PRODUCTLIST_ITEMS_CHANGED'], primaryContainer: self.options.primaryContainer}, document.title, targetUrl);
			self.$t.trigger('EDEESHOP_PRODUCTLIST_ITEMS_CHANGED');
			$(document).trigger('FG_UNIVERSAL_PRELOADER_STOP', 'PRODUCTLIST_ITEMS_CHANGE');
		});
	}
};

/**
 * decide, which methods will be "public"
 */
var API = {
	//method: PluginSkeleton.prototype.method
	//loadMarkers: GoogleMap.prototype.loadMarkers
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *    if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			//doplnit PluginName
			plugin = new ProductListFilter(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};

/**
 * setDefaults with $.pluginSkeleton.setDefaults();
 */
$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
$[PLUGIN_NAME].setDefaults = function (newOptions) {
	DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.product-list-filter.js